/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { ApplicationType } from "./application-type-types"

/**
 * Determines whether an application type matches a free-text query.
 *
 * The query is matched case-insensitively as a substring against the category,
 * description, platform, and source package name. Identity fields (`id`,
 * `organizationId`) are intentionally excluded from search.
 *
 * @param appType - The application type to test.
 * @param filterQuery - The free-text query. Leading/trailing whitespace is
 *   ignored; an empty query matches all application types.
 * @returns `true` if any searchable field contains the query.
 *
 * @remarks
 * Centralizes the searchable fields so all filter UIs behave consistently.
 */
export function matchesQuery(appType: ApplicationType, filterQuery: string): boolean {
    const query = filterQuery.trim().toLowerCase()

    if (query === "") {
        return true
    }

    return [appType.category, appType.description, appType.platform, appType.sourcePackageName].some((field) =>
        (field ?? "").toLowerCase().includes(query)
    )
}
